import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=25e2d433&scoped=true"
import script from "./Press.vue?vue&type=script&lang=js"
export * from "./Press.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e2d433",
  null
  
)

export default component.exports